import { CartResponseLineItemType } from '../../../apis/src/cart/types';

export const spendAndSavePrefix = 'CART#';

export type BasketPromoProps = {
  sku: string;
  quantity: string;
  amount: string;
  message: string;
  promoId: string;
};

export const toBasketPromos = (lineItems: Array<CartResponseLineItemType>) => {
  const promos = lineItems
    .filter(item => item.LineTotalDiscountInc > 0)
    .map(item => {
      const itemPromotions = item.Promotions.map(promotion => {
        return promotion.DiscountInc > 0 &&
          !promotion.CouponName.startsWith(spendAndSavePrefix) &&
          promotion.PromotionType !== 'Perks'
          ? promotion.Name
          : null;
      }).filter(promotion => promotion);
      const totalDiscount = item.Promotions.reduce((acc, current) => {
        if (
          (current.PromotionType === 'Coupon' && current.CouponName.startsWith(spendAndSavePrefix)) ||
          current.PromotionType === 'Perks'
        ) {
          return acc;
        }

        return acc + current.DiscountInc;
      }, 0);
      if (totalDiscount > 0) {
        return {
          sku: item.SKU,
          quantity: item.Quantity ? item.Quantity.toString() : '1',
          amount: Math.round(totalDiscount * 100).toString(),
          message: item.Promotions ? itemPromotions.join('; ') : '',
          promoId: item.Id ?? '',
        };
      }
    })
    .filter(item => item);

  return promos;
};
